import React from 'react';
import { Pages } from '../../../constants';
import BrowsePage from '../BrowsePage';
import SearchPage from '../SearchPage';
import DailyDeviationPage from '../DailyDeviationPage';
import TagPage from '../TagPage';
import TopicPage from '../TopicPage';
import TopicListPage from '../TopicListPage';
import PostsPage from '../PostsPage';

export interface Props {
  page: Pages;
  isSingleTopicPage?: boolean;
}

const Page: React.FC<Props> = ({ page, isSingleTopicPage }) => {
  switch (page) {
    case Pages.DailyDeviation:
      return <DailyDeviationPage />;
    case Pages.Search:
      return <SearchPage />;
    case Pages.Tag:
      return <TagPage />;
    case Pages.Topics:
      // TODO: seems like we should combine these two into one component and
      // switch later on (removing the topic prop from App)
      return isSingleTopicPage ? <TopicPage /> : <TopicListPage />;
    case Pages.Posts:
      return <PostsPage />;
    default:
      return <BrowsePage />;
  }
};
Page.displayName = 'Page';

export default Page;
